import * as React from 'react'
import DealsTileItem from './DealsTileItem'
import DealsTileSkeleton from './DealsTileSkeleton'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'

interface Props {
  carouselRef?: React.RefObject<HTMLDivElement | null>
  deals?: Array<App.Cruises.CruiseDealBase>
  isLoading?: boolean
}

function DealsTile(props: Props) {
  const { carouselRef, deals, isLoading } = props

  if (isLoading) {
    return <DealsTileSkeleton />
  }

  return <FullWidthCarouselWithAnalytics
    snap="start"
    ref={carouselRef}
  >
    {deals?.map((deal) => <DealsTileItem
      key={deal.id}
      backgroundColour={deal.pageColour}
      logoImageId={deal.cruiseLine.whiteImageId ?? ''}
      shipImageId={deal.heroImageId}
      variant="carousel"
      {...deal}
    />)}
  </FullWidthCarouselWithAnalytics>
}

export default DealsTile
